export default () => {
  /* istanbul ignore else */
  if (process.env.GRAPHQL_MOCK) {
    return require('../../mocks/apollo-client-mock').default; // eslint-disable-line global-require
  } else {
    return require('./clients/apollo-client').default; // eslint-disable-line global-require
  }
};



// WEBPACK FOOTER //
// ./src/app/apollo-client.js